import { Suspense, lazy } from 'react';
import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';

/**
 * Thin route shell. The dashboard UI — and, crucially, Recharts — lives in
 * analytics-content.tsx and is pulled in via a dynamic import() so it ships as a
 * separate async chunk loaded only when an admin opens this page (keeping
 * Recharts out of the main bundle). This module must NOT statically import the
 * charts, or the router's eager `Route` import would drag them back in.
 */
const AnalyticsContent = lazy(() => import('./analytics-content.js'));

function AnalyticsFallback() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="flex items-center gap-3 text-muted">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-navy/20 border-r-navy" />
        <span className="text-sm">Loading analytics…</span>
      </div>
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/analytics',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'admin' && role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: () => (
    <Suspense fallback={<AnalyticsFallback />}>
      <AnalyticsContent />
    </Suspense>
  ),
});
